import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import ResultsEditor from './editor';

// Thin drawer wrapper around ResultsEditor for the feed composer's
// `/resultat` slash command — same shape as fishCatch/drawer.js: local
// working state, the extracted editor, and Lagre/Avbryt buttons.
//
// ResultsEditor already debounces individual field edits internally and
// calls onChange with the freshly-updated array on every mutation (add,
// delete, debounced field edit, CSV import, ...). This wrapper just mirrors
// that into its own state so the Lagre button always has the latest working
// copy to hand back — the actual persistence decision (accumulate on
// newArticle vs. saveField against a saved article) is the caller's
// (article/edit.js), exactly like FishCatchDrawer's onSave.
@observer
class ResultsDrawer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            resultsLists: props.resultsLists || [],
        };
    }

    handleChange = (updated) => {
        this.setState({ resultsLists: updated });
    }

    saveResults = () => {
        const { onSave, drawerLevel = 1 } = this.props;
        const { appState } = this.props.stores;
        onSave(this.state.resultsLists);
        if (appState?.toggleDrawer) {
            appState.toggleDrawer(false, drawerLevel);
        }
    }

    cancelResults = () => {
        const { onCancel, drawerLevel = 1 } = this.props;
        const { appState } = this.props.stores;
        onCancel();
        if (appState?.toggleDrawer) {
            appState.toggleDrawer(false, drawerLevel);
        }
    }

    render() {
        const { images } = this.props;
        const { resultsLists } = this.state;

        return (
            <div class='results-drawer'>
                <div class='w-100 d-flex justify-content-center'>
                    <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                        <div class='font-weight-lighter px-3 box-header mt-0'>
                            <Text id='results.title'>Add results</Text>
                        </div>

                        <div class='px-3 mt-2'>
                            <div class='card'>
                                <div class='card-body'>
                                    <ResultsEditor
                                        resultsLists={resultsLists}
                                        images={images}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class='w-100 d-flex justify-content-end mt-3 px-4 py-3 bg-body-secondary fixed-bottom'
                    style='bottom: 0; left: 0;'
                >
                    <button
                        type='button'
                        class='btn btn-outline-secondary rounded-pill me-2'
                        data-testid='results-cancel'
                        onClick={this.cancelResults}
                    >
                        <i class='fa-solid fa-xmark me-1' />
                        <Text id='results.cancel'>Cancel</Text>
                    </button>
                    <button
                        type='button'
                        class='btn btn-primary rounded-pill'
                        data-testid='results-save'
                        onClick={this.saveResults}
                    >
                        <i class='fa-solid fa-check me-1' />
                        <Text id='results.save'>Save</Text>
                    </button>
                </div>
            </div>
        );
    }
}

export default ResultsDrawer;
